import { render } from "./Studio15Screen.vue?vue&type=template&id=6e689d44&scoped=true&ts=true&lang=pug"
import script from "./Studio15Screen.vue?vue&type=script&lang=ts"
export * from "./Studio15Screen.vue?vue&type=script&lang=ts"

import "./Studio15Screen.vue?vue&type=style&index=0&id=6e689d44&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e689d44"]])

export default __exports__